import ciudad_dep from "./ciudad_dep.jpg";
import housePreview from "./h1.jpg";
import artemisa from "./artemisa.jpg";
import sacos from "./sacos.jpg";
import hiniesta from "./hiniesta.jpg"
import albuquerque from "./albuquerque.png"

// Proyectos de Viviendas
export const houseData = [

  {
    id: "house1",
    backgroundImage: housePreview, 
    subtitle: "Nuestros Proyectos: Promoción inmobiliaria",
    title: "8 Viviendas Quéntar, Granada",
    description: "Proyecto residencial con enfoque en eficiencia energética en la localidad de Quéntar.",
  }
];

// Proyectos de Construcción
export const constData = [
  {
    id: "const1",
    backgroundImage: ciudad_dep,
    subtitle: "Nuestros Proyectos: Obra Civil y Edificación",
    title: "Ciudad Deportiva",
    description: "Complejo deportivo con instalaciones de última generación.",
  }
];

// Proyectos de Paneles Solares
export const panelData = [
  {
    id: "panel1",
    backgroundImage: artemisa,
    title: "8 MW en Artemisa, Cuba",
    subtitle: "Nuestros Proyectos: Paneles Solares",
    description: "Construcción de una planta solar fotovoltaica de 8 MW en la provincia de Artemisa.",
  },
  {
    id: "panel2",
    backgroundImage: albuquerque,
    title: "2 MW en Albuquerque, Badajoz",
    subtitle: "Nuestros Proyectos: Paneles Solares",
    description: "Desarrollo de una planta solar fotovoltaica de 2 MW en Albuquerque, España.",
  },
  {
    id: "panel3",
    backgroundImage: hiniesta, 
    title: "La Hiniesta, Zamora",
    subtitle: "Nuestros Proyectos: Paneles Solares",
    description: "Instalación solar en La Hiniesta con tecnología de seguimiento solar.",
  },
  {
    id: "panel4",
    backgroundImage: sacos,
    title: "Sacos Dúrcal, Granada",
    subtitle: "Nuestros Proyectos: Paneles Solares",
    description: "Proyecto fotovoltaico para la fábrica de Sacos Durcal.",
  },

];